import { createSlice } from "@reduxjs/toolkit";
import { GetAllGeneralDashboard } from "./dashboardApi";
import { getToday } from "helpers/utils";

const DashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    generalDashboardData: [],
    dashboardFilters: {
      branches: [],
      payer: "",
      date: [getToday(), getToday()],
    },
  },
  reducers: {
    handleDashboardFilter: (state, action) => {
      state.dashboardFilters[action?.payload?.check] = action?.payload?.value;
    },
    handleResetDashboardFilter: (state, _) => {
      state.dashboardFilters = {
        branches: [],
        payer: "",
        date: null,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(GetAllGeneralDashboard.fulfilled, (state, action) => {
      state.generalDashboardData = action?.payload?.data;
    });
  },
});
export const { handleDashboardFilter, handleResetDashboardFilter } =
  DashboardSlice.actions;
export default DashboardSlice.reducer;
